import type React from 'react'
import type { SwapDto } from '../../../../../../types/coreApi-types'
import Swaps from '../../Transfers/components/Swaps'

interface TransfersProps {
  swaps?: SwapDto[]
}

const Transfers: React.FC<TransfersProps> = ({ swaps }) => {
  return (
    <div className="space-y-3">
      <h1 className="h1">OTC Transfers</h1>
      <Swaps swapsData={swaps} ignoreUserLink />
    </div>
  )
}

export default Transfers
